import { ReactNode } from 'react';
import { AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';

interface AlertBoxProps {
  title: string;
  message: ReactNode;
  variant?: 'success' | 'error' | 'info' | 'warning';
  icon?: ReactNode;
}

export default function AlertBox({
  title,
  message,
  variant = 'info',
  icon,
}: AlertBoxProps) {
  const baseStyle = 'flex items-start gap-3 p-4 rounded-md text-sm';
  let style = '';
  let defaultIcon: ReactNode = null;

  if (variant === 'success') {
    style = 'bg-[#CCFBF1] text-[#0F766E] border border-green-300';
    defaultIcon = <CheckCircle className="w-5 h-5" />;
  } else if (variant === 'error') {
    style = 'bg-red-100 text-red-800 border border-red-300';
    defaultIcon = <AlertCircle className="w-5 h-5" />;
  } else if (variant === 'warning') {
    style = 'bg-orange-100 text-orange-800 border border-orange-300';
    defaultIcon = <AlertTriangle className="w-5 h-5" />;
  } else {
    style = 'bg-blue-100 text-blue-800 border border-blue-300';
    defaultIcon = <Info className="w-5 h-5" />;
  }
  return (
    <div className={`${baseStyle} ${style}`}>
      <div className="shrink-0 mt-0.5 rounded-full border-2 border-white bg-white/50 p-1">
        {icon || defaultIcon}
      </div>
      <div>
        <p className="text-lg font-semibold">{title}</p>
        <div className="text-base font-normal leading-snug">{message}</div>
      </div>
    </div>
  );
}
